import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class PopularEventsService {
  popularEvents = new BehaviorSubject<any[]>([]);
  storage = inject(StorageService);

  constructor() {
    const localPopularEvents = this.localPopularEvents;
    if (localPopularEvents) {
      this.popularEvents.next(localPopularEvents);
    }
  }

  getPopularEvents(): Observable<any> {
    return this.popularEvents.asObservable();
  }

  get localPopularEvents() {
    // return sessionStorage.getItem("popularEvents");
    return this.storage.getItem<any>("popularEvents");
  }

  setPopularEvents(items: any[]) {
    // console.log(items);
    // sessionStorage.setItem("popularEvents", JSON.stringify(items));
    this.storage.setItem("popularEvents", items);
    this.popularEvents.next(items);
  }

  add(item: any) {
    if (!this.eventExists(item?.id)) {
      this.setPopularEvents([...this.popularEvents.value, item]);
    }
  }

  removeAll() {
    this.setPopularEvents([]);
  }

  eventExists(id: any) {
    return this.popularEvents.value.some((x: any) => x.id === id);
  }
}
